import { forwardRef } from 'react';
import { Link, useLocation, type LinkProps } from 'react-router-dom';
import { getSignupHref } from '@/lib/attribution';

const SignupLink = forwardRef<HTMLAnchorElement, Omit<LinkProps, 'to'>>((props, ref) => {
  const { search } = useLocation();
  return <Link {...props} ref={ref} to={getSignupHref(search)} />;
});

SignupLink.displayName = 'SignupLink';
export default SignupLink;
